import * as React from 'react';
import { useSelector } from 'react-redux';

import { FilterTooltip } from '../../components/FilterTooltip';
import { RoomFilter } from './RoomFilter';
import { RoomsQuickFilterTooltip } from '../../components/RoomsQuickFilter';
import { roomsDescriptor } from '../../constants/descriptors';
import { isDescriptorActive } from '../../utils/filters';
import { IApplicationState } from '../../types/redux';

const getRoomButtonText = (activeDescriptors: typeof roomsDescriptor): string => {
  if (activeDescriptors.length === 0) {
    return 'Комнаты';
  }

  if (activeDescriptors.length === 1) {
    return activeDescriptors[0].label;
  }

  // Для множественного выбора используем сокращения
  const roomNumbers: string[] = [];
  const specialTypes: string[] = [];

  activeDescriptors.forEach(descriptor => {
    if (descriptor.state === 'studio') {
      specialTypes.push('студия');
    } else if (descriptor.state === 'openPlan') {
      specialTypes.push('свободная планировка');
    } else {
      roomNumbers.push(descriptor.shortLabel as string);
    }
  });

  const parts: string[] = [];

  if (roomNumbers.length > 0) {
    parts.push(`${roomNumbers.join(', ')} комн.`);
  }

  if (specialTypes.length > 0) {
    parts.push(specialTypes.join(', '));
  }

  return parts.join(', ');
};

export const Rooms = () => {
  const jsonQuery = useSelector((state: IApplicationState) => state.jsonQuery);

  const activeDescriptors = React.useMemo(
    () => roomsDescriptor.filter(descriptor => isDescriptorActive(descriptor)(jsonQuery)),
    [jsonQuery],
  );

  const buttonText = React.useMemo(() => getRoomButtonText(activeDescriptors), [activeDescriptors]);

  return (
    <FilterTooltip buttonText={buttonText} maxWidth={186} dataTestId="RoomsQuickFilter">
      <RoomsQuickFilterTooltip>
        <RoomFilter autoApply />
      </RoomsQuickFilterTooltip>
    </FilterTooltip>
  );
};
